import { render, staticRenderFns } from "./CostDataForm.vue?vue&type=template&id=39523044&"
import script from "./CostDataForm.vue?vue&type=script&lang=js&"
export * from "./CostDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports